import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';

const LOG_ERROR = gql`
  mutation LogFrontendError($errorLogInput: ErrorLogInput!) {
    logFrontendError(errorLogInput: $errorLogInput)
  }
`;

const LOG_ERROR_WITHOUT_AUTH = gql`
  mutation LogFrontendErrorWithoutAuth($errorLogInput: ErrorLogInput!) {
    logFrontendErrorWithoutAuth(errorLogInput: $errorLogInput)
  }
`;

function useLogFeError(isAuthEnabled = false) {
  const [logError] = useMutation(isAuthEnabled ? LOG_ERROR : LOG_ERROR_WITHOUT_AUTH);
  return {
    logErrorToServer: async (errorInput) => {
      let userEmail = '';
      try {
        const ctx = JSON.parse(window.localStorage.getItem('sessionContext') || '{}');
        userEmail = ctx.email || ctx.id || '';
      } catch (e) { /* ignore */ }
      const enriched = {
        ...errorInput,
        message: userEmail ? `[user: ${userEmail}] ${errorInput.message}` : errorInput.message
      };
      return logError({ variables: { errorLogInput: enriched } });
    }
  };
}

export default useLogFeError;
